import {Injectable} from '@angular/core';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';

@Injectable({providedIn: 'root'})
export class DeviceTypeService extends AbstractProdSelectService {
  override selectDataUrl: string = 'deviceTypes';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };
}
